<template>
    <el-dropdown class="user-info-dropdown" @command="handleCommand" trigger="click">
        <div class="user-info">
            <span class="user-header">
                {{userHeaderText}}
            </span>
            <span class="user-name">
                <span class="dwname">
                    {{truename}}{{showModel ? dwname : ''}}
                    <btn-eye v-model="showModel"></btn-eye>
                </span>
                <i class="el-icon-caret-bottom" style="float:left;margin-top:3px"></i>
            </span>
        </div>

        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
            v-for="(item, index) in navDeopDownList"
            :key="index"
            :icon="item.icon"
            :command="item.command">
                {{item.text}}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
import BtnEye from './btn-eye';

export default {
    components: {
        BtnEye,
    },
    props: {
        show: {
            props: {
                type: Boolean,
                default: true,
            },
        }
    },
    data () {
        return {
            
        }
    },
    computed: {
        userInfo() {
            return this.$store.getters.user;
        },
        truename() {
            
            return this.userInfo.truename || '游客';
            
        },
        dwname() {
            return this.userInfo.dwname ? `· ${this.userInfo.dwname}` : '';
        },
        userHeaderText() {
            return this.truename.slice(0, 1);
        },
        navDeopDownList() {
            return this.getGetters(`${this.getGetters('system').type}_navDropDown`)
        },
        showModel: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            },
        },
    },
    methods: {
        handleCommand(command) {
            command && command();
        }
    },
    mounted: function() {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$headerSize:1.5em;

.user-info-dropdown{display:block; float:right;
    .user-info{font-size:16px; padding:0 1em; margin-top:15px; cursor:pointer;
        .user-header{float: left; color:white; background:#304156; border-radius:50%; width:$headerSize; height:$headerSize; line-height:$headerSize; text-align:center;;}
        .user-name{font-size:14px; margin-left:.5em; margin-top: 2px; float: left; overflow: hidden;}
    }
}
.dwname{ overflow: hidden; text-overflow:ellipsis; white-space: nowrap; float: left; margin: 0 5px;}
</style>
